import { MRT_ColumnDef, MRT_PaginationState } from "material-react-table";
import { useState } from "react";
import {
  Box,
  Button,
  Chip,
  IconButton,
  Typography,
} from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import { DataTable } from "../../libs/core/components/data-table";
import { useGetPartnersQuery, useDeletePartnerMutation } from "./api/partnersApi";
import { ConfirmModal } from "../../libs/ui/modal/confirm_modal";
import { Partner } from "./types/partner";
import { appEndpoint } from "../../store/app.endpoint";
import AddEditPartner from "./componets/AddEditPartner";

const PartnerManager: React.FC = () => {
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });

  const [openDialog, setOpenDialog] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [selectedPartner, setSelectedPartner] = useState<Partner | null>(null);

  const {
    data: partners,
    isLoading,
    isError,
    isFetching,
  } = useGetPartnersQuery();
  const [deletePartner] = useDeletePartnerMutation();

  const columns: Array<MRT_ColumnDef<Partner>> = [
    {
      header: "Company Name",
      accessorKey: "company_name",
      size: 200,
    },
    {
      header: "Logo",
      accessorKey: "logo",
      size: 100,
      Cell({ row: { original } }) {
        return original.logo ? (
          <img
            src={original.logo}
            alt="Logo"
            width={60}
            style={{ borderRadius: 6 }}
          />
        ) : (
          <Typography variant="body2" color="text.secondary">
            No Logo
          </Typography>
        );
      },
    },
  
  ];

  return (
    <Box>
      <DataTable<Partner>
        toolbar={
          <Box display="flex" alignItems="center" width="100%">
            <Box display="flex" gap={3} alignItems="center" flex="1">
              <Typography variant="h6">Partners</Typography>
              <Chip
                color="primary"
                variant="outlined"
                label={`${partners?.data?.length ?? 0} Partners`}
              />
            </Box>
            <Button
              onClick={() => {
                setSelectedPartner(null);
                setOpenDialog(true);
              }}
              sx={{ minWidth: "200px" }}
              variant="contained"
            >
              Add New Partner
            </Button>
          </Box>
        }
        list={partners?.data ?? []}
        count={partners?.data?.length ?? 0}
        columns={columns}
        getRowId={(row) => row?.id?.toString()}
        isLoading={isLoading}
        isSuccess={!isError}
        isError={isError}
        isFetching={isFetching}
        renderRowActions={(row) => (
          <Box display="flex" gap={1}>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                setSelectedPartner(row);
                setOpenConfirmModal(true);
              }}
            >
              <Delete />
            </IconButton>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                setSelectedPartner(row);
                setOpenDialog(true);
              }}
            >
              <Edit />
            </IconButton>
          </Box>
        )}
        pagination={pagination}
        onPaginationChange={setPagination}
      />

      <AddEditPartner
        open={openDialog}
        partner={selectedPartner}
        setModalOpen={setOpenDialog}
      />

      {selectedPartner && (
        <ConfirmModal
          type="warning"
          title="Delete Partner"
          message={`Are you sure you want to delete '${selectedPartner.company_name}'?`}
          modalOpen={openConfirmModal}
          setModalOpen={setOpenConfirmModal}
          onOk={() => {
            deletePartner({ id: selectedPartner.id.toString(), body: null });
            setOpenConfirmModal(false);
            setSelectedPartner(null);
          }}
        />
      )}
    </Box>
  );
};

export default PartnerManager;
